import { faCogs } from '@fortawesome/pro-solid-svg-icons/faCogs';
import { faFolder } from '@fortawesome/pro-solid-svg-icons/faFolder';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import { faScaleBalanced } from '@fortawesome/pro-solid-svg-icons/faScaleBalanced';
import { faStars } from '@fortawesome/pro-solid-svg-icons/faStars';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTour } from '@reactour/tour';
import {
	Button,
	ButtonSize,
	ColourStateSolid,
	ColourStateOutline,
	Directions,
	Drawer,
	FlexGap,
	StackVertical,
	Tooltip,
	useOutsiderDetector,
	ButtonGroup,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router';

function MailboxInfo() {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const { setIsOpen } = useTour();

	const [showInfo, setShowInfo] = useState<boolean>(false);

	const mailInfoRef = useRef<HTMLDivElement>(null);

	useOutsiderDetector(mailInfoRef, () => setShowInfo(false));

	return (
		<>
			<ButtonGroup verticalCenter tipChildren>
				<Tooltip content={t('mailboxes.infoDrawer.title')}>
					<Button
						title={t('mailboxes.infoDrawer.title')}
						iconOnly
						squared
						icon={faInfoCircle}
						colour={ColourStateSolid.Secondary}
						onClick={() => setShowInfo(true)}
					/>
				</Tooltip>
			</ButtonGroup>

			<Drawer
				title={t('mailboxes.infoDrawer.title')}
				isOpen={showInfo}
				direction={Directions.End}
				closeCallback={() => setShowInfo(false)}
			>
				<StackVertical gap={FlexGap.ExtraLarge}>
					<StackVertical>
						<div className='h6 mb-xs'>
							<FontAwesomeIcon icon={faCogs} /> Mail Settings
						</div>
						<p>
							You can change your mail settings to automatically open and scan received mail, forward
							scanned mail to your e-mail, set the default number of pages scanned, as well as many other
							options.
						</p>
						<Button title='Show Me' size={ButtonSize.Small} alignLeft colour={ColourStateOutline.Primary} />
					</StackVertical>

					<StackVertical>
						<div className='h6 mb-xs'>
							<FontAwesomeIcon icon={faFolder} /> Custom Mail Folders
						</div>
						<p>Create custom folders to further categorise and organise your mail items.</p>
						<Button title='Show Me' size={ButtonSize.Small} alignLeft colour={ColourStateOutline.Primary} />
					</StackVertical>

					<StackVertical>
						<div className='h6 mb-xs'>
							<FontAwesomeIcon icon={faScaleBalanced} /> Custom Rule-sets
						</div>
						<p>
							Create rule-sets for your mail items that allow you to automatically action, forward, and
							organise your mail items.
						</p>
						<Button
							title='Show Me'
							size={ButtonSize.Small}
							alignLeft
							colour={ColourStateOutline.Primary}
							onClick={() => navigate('/manage-account/rulesets')}
						/>
					</StackVertical>

					<Button
						icon={faStars}
						onClick={() => {
							setShowInfo(false);
							setIsOpen(true);
						}}
						title={t('mailboxes.actions.startTour')}
						squared
					/>
				</StackVertical>
			</Drawer>
		</>
	);
}

export { MailboxInfo };
